import {HttpClient, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from "@angular/common/http";
import {Injectable, Injector, OnDestroy} from "@angular/core";
import {Observable} from "rxjs/Observable";
import {Subject} from "rxjs";
import {FilterBuilder, FilterCriteria} from "@synisys/idm-de-core-frontend";
import {catchError, switchMap} from "rxjs/operators";
import {of} from "rxjs/observable/of";
import {Tree} from "./me-tree-shaking-interceptor";
import {Router} from "@angular/router";

@Injectable()
export class BeneficiaryInterceptor implements HttpInterceptor, OnDestroy {

    private httpClient: HttpClient;

    private destroy$: Subject<boolean> = new Subject<boolean>();

    ngOnDestroy(): void {
        this.destroy$.next(true);
        this.destroy$.unsubscribe();
    }

    constructor(private injector: Injector,
                private router: Router) {

    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        !this.httpClient && this.injectDependencies();
        if (!this.isNeededRequest(req)) {
            return next.handle(req);
        }
        return this.isGrantBeneficiaryForm().pipe(
            switchMap((needToIntercept) => {
                if (needToIntercept) {
                    return this.applyFilter(req, next).pipe(
                        switchMap((response: HttpResponse<Tree>) => of(response))
                    );
                } else {
                    return next.handle(req);
                }
            }),
            catchError((error) => {
                console.error(error);
                return next.handle(req);
            })
        );
    }

    private applyFilter(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        req.body.filter = this.defineFilter(req);
        return next.handle(req);
    }

    private getGrantInstanceIdStr(): string {
        let grantInstanceId: number = +this.router.routerState.snapshot.root.queryParams.gid;
        return ',' + grantInstanceId + ',';
    }

    private defineFilter(req: HttpRequest<any>): any {
        if (!Object.keys(req.body.filter).length) {
            return this.getExtraFilter(this.getGrantInstanceIdStr());
        } else {
            let filterStr: string = JSON.stringify(req.body.filter);
            // if (filterStr.indexOf('grantInstanceIds') === -1) {
                let extraFilter: string = JSON.stringify(this.getExtraFilter(this.getGrantInstanceIdStr()));
                let moreThanOneFieldFilter: boolean = filterStr.indexOf('$and') !== -1;
                let newFilterStr: string;
                if (!moreThanOneFieldFilter) {
                    newFilterStr = `{"$and": [` + filterStr + ', ' + extraFilter + ']}';
                } else {
                    newFilterStr = filterStr.substring(0, filterStr.length - 2) + ', ' + extraFilter +
                        filterStr.substring(filterStr.length - 2);
                }
                return JSON.parse(newFilterStr);
            // }
        }
    }

    private isNeededRequest(req: HttpRequest<any>): boolean {
        return req.method === 'POST' && req.url.indexOf('/entitysearchservice/v1/agra/portfolio/entities') !== -1 &&
            req.body.category === 'Beneficiary';
    }

    private getExtraFilter(grantInstanceIdStr: string): any {
        let filterCriteria: FilterCriteria = new FilterBuilder().contains('grantInstanceIds', grantInstanceIdStr).build();
        return filterCriteria.toJson();
    }

    private isGrantBeneficiaryForm(): Observable<boolean> {
        let currentUrl = this.router.url;
        return Observable.of(currentUrl.indexOf('gid=') !== -1);
    }

    private injectDependencies(): void {
        this.httpClient = this.injector.get(HttpClient);
    }

}
